import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { useTrackProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../../exams';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamFailedScreen = ({
  trackId,
  language
}) => {
  const {
    trackProgress,
    trackProgressLoading,
    trackProgressError
  } = useTrackProgress(Number(trackId));
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.award;
  const examIsRecent = mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
  const certificationExpired = !examIsRecent && award && award.isExpired;
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [!certificationExpired && /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: track && (track.certification || !!track.exam),
        trackId: trackId,
        useCurrentText: mostRecentExamAttempt ? !mostRecentExamAttempt.passed : false
      }), /*#__PURE__*/_jsx(RetakeExamButton, {
        language: language,
        trackId: trackId,
        use: "primary"
      })]
    }),
    error: trackProgressError || trackError || mostRecentExamAttemptError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.failHeading"
    }),
    illustration: "missed-goal",
    language: language,
    loading: trackProgressLoading || trackLoading || mostRecentExamAttemptLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreVsRequiredScore",
      options: {
        passThreshold: mostRecentExamAttempt && mostRecentExamAttempt.passThreshold,
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.failSubheading"
    }),
    trackId: trackId
  });
};
export default ExamFailedScreen;